import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
@Injectable()
export class BeneficiaryEnrollmentDataService {
    private messageDataSource = new BehaviorSubject('default message')
    data = this.messageDataSource.asObservable()

    constructor() {}

    sendData(data: string) {
        this.messageDataSource.next(data)
    }
}
